/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForThreatsAws extends models.GovernanceConfigurationBaseForThreats {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForThreatsAws");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForThreatsAws.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForThreatsAws>): GovernanceConfigurationForThreatsAws {
        let obj = Object.assign(new GovernanceConfigurationForThreatsAws(), model);
        GovernanceConfigurationForThreatsAws.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForThreatsAws>): GovernanceConfigurationForThreatsAws {
        if (!model) return null;
        return GovernanceConfigurationForThreatsAws.newInstance(<GovernanceConfigurationForThreatsAws> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForThreatsAws) {
        if (!obj) return;

        models.GovernanceConfigurationForThreatsAws.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForThreatsAws): boolean {
        if (models.GovernanceConfigurationBaseForThreats.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForThreatsAws.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Region Id
     */
    region: string;

    /**
     * S3 bucket designated for publishing
     */
    bucket_name: string;

    /**
     * KMS Key name for encryption
     */
    kms_key: string;

}
